export const formatDate = (isoString: string): string => {
  const date = new Date(isoString)
  const month = String(date.getMonth() + 1).padStart(2, '0') // Months are 0-based
  const day = String(date.getDate()).padStart(2, '0')
  const year = date.getFullYear()
  const hours = String(date.getHours()).padStart(2, '0')
  const minutes = String(date.getMinutes()).padStart(2, '0')

  return `${month}.${day}.${year} ${hours}:${minutes}`
}

export const formatUsageStatsDate = (value: string | null):string => {
  if (!value) return 'No activity yet'
  return new Date(value).toLocaleString()
}

export const formatTime = (timestamp: string): string => {
  const date = new Date(timestamp)
  return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
}

export const formatDateRelative = (timestamp: string): string => {
  const date = new Date(timestamp)
  const today = new Date()
  const yesterday = new Date(today)
  yesterday.setDate(yesterday.getDate() - 1)

  if (date.toDateString() === today.toDateString()) {
    return 'Today'
  } else if (date.toDateString() === yesterday.toDateString()) {
    return 'Yesterday'
  } else {
    return date.toLocaleDateString([], { month: 'short', day: 'numeric' })
  }
}

export const convertLocalToUTC = (localDateTimeString: string) => {
  if (!localDateTimeString) return new Date().toISOString()

  const localDate = new Date(`${localDateTimeString}:00`)
  return localDate.toISOString()
}

export const convertUTCToLocal = (utcDateTimeString: string) => {
  if (!utcDateTimeString) {
    const now = new Date()
    return now.toISOString().slice(0, 16)
  }

  try {
    const utcDate = new Date(utcDateTimeString)

    if (isNaN(utcDate.getTime())) {
      console.error('Invalid UTC date:', utcDateTimeString)
      return new Date().toISOString().slice(0, 16)
    }

    const localDate = new Date(
      utcDate.getTime() - utcDate.getTimezoneOffset() * 60000
    )
    return localDate.toISOString().slice(0, 16)
  } catch (error) {
    console.error('UTC to local conversion error:', error)
    return new Date().toISOString().slice(0, 16)
  }
}

export const getCurrentLocalDateTime = () => {
  const now = new Date()
  const localDate = new Date(now.getTime() - now.getTimezoneOffset() * 60000)
  return localDate.toISOString().slice(0, 16)
}

export const addSecondsToDateTime = (dateTimeString: string) => {
  if (!dateTimeString) return new Date().toISOString()
  if (
    dateTimeString.includes('T') &&
    dateTimeString.split('T')[1].split(':').length === 3
  ) {
    return new Date(dateTimeString).toISOString()
  }
  return convertLocalToUTC(dateTimeString)
}
